import React from 'react';
import { Avatar, Box, Hidden, Typography, BoxProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { getTimeText } from '../services/datetime';
export type Props = { discussion: ITopicDiscussion } & BoxProps;

const useStyles = makeStyles({
  avatar: {
    marginRight: 16,
  },
  caption: {
    color: '#D0D7E1',
    fontSize: '0.75rem',
    marginTop: 4,
    opacity: 0.75,
  },
  clampText: {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
});

const DiscussionItem: React.FC<Props> = ({ discussion, ...props }) => {
  const { avatar, caption, clampText } = useStyles();
  return (
    <Box bgcolor='#454057' p={2} {...props}>
      <Box display='flex' justifyContent='space-between' mb={2}>
        <Box
          display='flex'
          alignItems='center'
          width={{ xs: '100%', md: '500px' }}
        >
          <Avatar className={avatar} src={discussion.avatar} />
          <Box minWidth='0px'>
            <Typography variant='h6' noWrap title={discussion.title}>
              {discussion.title}
            </Typography>
            <Typography className={caption} noWrap>
              โพสต์โดย&nbsp;
              <Box
                component='span'
                color={'#81E6D9'}
                style={{ opacity: discussion.author ? 1 : 0.5 }}
              >
                {discussion.author ? discussion.author : 'ไม่มีชื่อ'}
              </Box>
              &nbsp;({discussion.uid.substring(0, 5)}xxx)&nbsp;เมื่อ{' '}
              {getTimeText(discussion.createdAt)}
            </Typography>
          </Box>
        </Box>
        <Hidden smDown>
          <Typography className={caption} variant='caption'>
            {discussion.commentCount} ตอบกลับ
          </Typography>
        </Hidden>
      </Box>
      <Typography className={clampText}>{discussion.content}&nbsp;</Typography>
    </Box>
  );
};

export default DiscussionItem;
